export const LOCATION_SUGGESTIONS_API_ROUTE = `/next/api/common/location-suggestions`;
